import { TRAIN_BASE_URL } from "../utils/urls";
import Cookies from "js-cookie";
const fetchDataTraining = async ({ uri }: any) => {
  const token = Cookies.get("token");
  const response = await fetch(`${TRAIN_BASE_URL}/${uri}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
  if (response.status !== 200) {
    return Promise.reject("Something Went Wrong");
  }
  return response.json();
};

const postDataTraining = async ({ data, uri }: any) => {
  const token = Cookies.get("token");
  const response = await fetch(`${TRAIN_BASE_URL}/${uri}`, {
    method: "POST",
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(data),
  });
  if (response.status !== 200) {
    return Promise.reject("Something Went Wrong");
  }
  return response.json();
};

const patchDataTraining = async ({ data, uri }: any) => {
  const token = Cookies.get("token");
  const response = await fetch(`${TRAIN_BASE_URL}/${uri}`, {
    method: "PATCH",
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(data),
  });
  if (response.status !== 200) {
    return Promise.reject("Something Went Wrong");
  }
  return response.json();
};

const putDataTraining = async ({ data, uri }: any) => {
  const token = Cookies.get("token");
  const response = await fetch(`${TRAIN_BASE_URL}/${uri}`, {
    method: "PUT",
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(data),
  });
  if (response.status !== 200) {
    return Promise.reject("Something Went Wrong");
  }
  return response.json();
};

const deleteDataTraining = async ({ data, uri }: any) => {
  const token = Cookies.get("token");
  const response = await fetch(`${TRAIN_BASE_URL}/${uri}`, {
    method: "DELETE",
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(data),
  });
  if (response.status !== 200) {
    return Promise.reject("Something Went Wrong");
  }
  return response.json();
};

export {
  fetchDataTraining,
  postDataTraining,
  patchDataTraining,
  putDataTraining,
  deleteDataTraining,
};
